export default __webpack_public_path__ + "static/media/lataa.42086c4d.svg";